import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import actions from '@/store/actions';
import getters from '@/store/getters';
import mutations from '@/store/mutations';

import PersistStatePlugin from '@/store/plugins/PersistStatePlugin';
import Orm from '@/store/plugins/orm/Orm';

// Register Models to ORM
Orm.register('users');
Orm.register('roles');
Orm.register('sessions');
Orm.register('products');
Orm.register('product_categories');
Orm.register('product_ingredients');
Orm.register('tax_rates');
Orm.register('orders');
Orm.register('order_items');
Orm.register('order_item_comments');
Orm.register('clients');
Orm.register('sectors');
Orm.register('tables');
Orm.register('grids');
Orm.register('buttons');
Orm.register('shifts');
Orm.register('cash_registers');
Orm.register('cash_register_transactions');
Orm.register('shortcuts');
Orm.register('user_transactions');
Orm.register('pricelists');
Orm.register('notifications');
Orm.register('app_events');
Orm.register('kitchen_tickets');
Orm.register('kitchen_ticket_items');
Orm.register('terminals');

const state = {
    lastTenant: null,
    tenant: null,
    user: null,
    curOrder: null,
    curOrderItem: null,
    curUnpaidOrders: [],
    pendingCardPayment: null,
    pausedOrder: null,
    curTable: null,
    curGuest: 0,
    appConfig: null,
    printConfig: null,
    isOnline: true,
    localConnection: { connected: false, isServer: false, serverAddress: null, serverPort: null, terminals: [] },
    device: null,
    syncInProgress: false,
    syncOptions: { limit: 50, timeout: 120000, autoSyncDisabled: false },
    workingDays: [],
    updatePending: false,
    impersonate: false,
    initialized: false,
    trainingMode: false,
    tableMode: null,
    tablePermissions: {},
    splitReceipt: { active: false, data: [] },
    activePricelist: 0,
    modules: {},
    integrations: {},
    kdsSettings: { itemsPerPage: [3, 6], fontSize: 'medium', yellowTimer: 5, redTimer: 7, filterForUser: false },
    activeSector: 0
};

const plugins = [Orm.plugin(), PersistStatePlugin];

export default new Vuex.Store({
    plugins,
    state,
    mutations,
    actions,
    getters,
});
